import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchReportingPeriodDropdown(app, params) {
  const { searchTerm, searchParams, dropdown_type = 'reporting_period/dropdown', fields, id } = params;
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownData(app, { query });
}

export function saveReportingExchangeRate(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  let exchangeRateData = {
    doc_type: DocType.REPORTING_EXCHANGE_RATE,
    effective_date: util.toStringDate(data.effective_date),
    currency_from_id: data.currency_from_id,
    currency_to_id: data.currency_to_id,
    rate: util.toDecimal(data.rate),
    period_id: data.period_id,
  };

  return common.saveDoc(app, {
    source: data,
    doc: exchangeRateData,
    user,
  });
}

export function deleteReportingExchangeRate(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.REPORTING_EXCHANGE_RATE
  });
}

export function fetchReportingExchangeRateById(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.REPORTING_EXCHANGE_RATE });
}

